import React, { useMemo } from 'react';
import Modal from '../../Atoms/Modal/Modal';
import styles from './RenameMediaModal.module.scss';
import folderIcon from '../../../assets/Imagess/folderICon.svg';
import Buttons from '../../Atoms/Buttons/Buttons';
import noImageFound from '../../../assets/Imagess/no-image-found.jpg';
import { useMutation } from 'react-query';
import axios from 'axios';
import { API_URL, securityHeaders } from '../../../Constants';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import TextInput from '../../Atoms/Inputs/TextInput';
import { useToast } from '../Custom/CustomToaster/Toast';
import { sanitizeAndValidateUrl } from '../../../app/helpers/sanitizeAndValidateUrl';
import hashIcon from '../../../assets/icons/formActions/inputs/hash.svg';
import CustomSelect from '../../Atoms/forms/customSelect/CustomSelect';

const RenameMediaModal = ({
  media,
  handleOnClose,
  refetchMedia,
  albumsCount,
}) => {
  const customizedToast = useToast();

  const initialValues = {
    albumNameAr: media?.galleryName_AR || '',
    orderId:
      typeof media?.orderId === 'number'
        ? media.orderId
        : typeof media?.OrderId === 'number'
        ? media.OrderId
        : '',
  };

  const validationSchema = Yup.object().shape({
    albumNameAr: Yup.string().required('الاسم مطلوب'),
    orderId: Yup.number()
      .typeError('الترتيب يجب أن يكون رقم')
      .integer('الترتيب يجب أن يكون رقم صحيح')
      .min(1, 'الترتيب يجب أن يكون أكبر من 0')
      .required('الترتيب مطلوب'),
  });

  const updateMediaGallery = useMutation({
    mutationFn: (fields) => {
      return axios.post(API_URL + `/api/News/MediaGallery`, fields, {
        headers: securityHeaders,
      });
    },
    onSuccess: () => {
      refetchMedia();
      handleOnClose();
      customizedToast.open('تم تحديث بيانات الألبوم');
    },
    onError: (error) => {
      alert(error?.message);
    },
  });

  const currentOrder =
    typeof media?.orderId === 'number'
      ? media.orderId
      : typeof media?.OrderId === 'number'
      ? media.OrderId
      : 0;

  const maxOrder = Math.max(
    Number(albumsCount || 0) + 1,
    Number(currentOrder || 0),
    1
  );

  const orderOptions = useMemo(() => {
    return Array.from({ length: maxOrder }, (_, i) => {
      const n = i + 1;
      return { value: n, text: String(n) };
    });
  }, [maxOrder]);
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      enableReinitialize
      onSubmit={(values) => {
        const formdata = new FormData();

        formdata.append('MediaGalleryId', media?.mediaGalleryId);
        formdata.append('GalleryName_AR', values.albumNameAr);
        formdata.append('OrderId', String(Number(values.orderId)));

        updateMediaGallery.mutate(formdata);
      }}
    >
      {({ values, errors, touched, setFieldValue, handleSubmit }) => {
        return (
          <Form>
            <Modal
              onClose={handleOnClose}
              width='838px'
              closeWhite={false}
              title='تعديل الألبوم'
            >
              <div className={styles['info-container']}>
                <div className={styles['modal-body-container']}>
                  <div>
                    <img
                      src={sanitizeAndValidateUrl(
                        `${media?.images?.[0]?.url}${media?.images?.[0]?.imageURL}`
                      )}
                      className={styles['modal-display-image']}
                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null;
                        currentTarget.src = noImageFound;
                      }}
                      alt=''
                    />
                  </div>

                  <div>
                    <div className={styles['rename-inputs']} dir='rtl'>
                      <TextInput
                        label='اسم الألبوم'
                        placeholder='أدخل الاسم'
                        icon={folderIcon}
                        value={values.albumNameAr}
                        name='albumNameAr'
                        onChange={(name, value) => setFieldValue(name, value)}
                        errors={errors.albumNameAr}
                        touched={touched.albumNameAr}
                        left
                      />

                      <CustomSelect
                        label='التسلسل'
                        placeholder='اختر رقم الترتيب'
                        icon={hashIcon}
                        value={values.orderId}
                        name='orderId'
                        onChange={(name, v) => setFieldValue(name, Number(v))}
                        options={orderOptions}
                        touched={touched.orderId}
                        errors={errors.orderId}
                        type='category'
                        left
                      />
                    </div>

                    <Buttons
                      text={
                        updateMediaGallery.isLoading
                          ? 'جاري التحديث...'
                          : 'تحديث'
                      }
                      rounded={true}
                      color='rgba(13, 160, 110, 1)'
                      handleOnClick={handleSubmit}
                      type='submit'
                      width='133px'
                      style={{
                        marginTop: '30px',
                        float: 'right',
                        fontSize: '20px',
                        fontFamily: 'BukraBold',
                      }}
                    />
                  </div>
                </div>
              </div>
            </Modal>
          </Form>
        );
      }}
    </Formik>
  );
};

export default RenameMediaModal;
